import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Formik, Field, Form, ErrorMessage } from 'formik';
import * as Yup from 'yup';

import { accountService, alertService } from '../_services';
import { useTranslation } from 'react-i18next';

function Update({ history }) {
    const { t } = useTranslation();
    const user = accountService.userValue;
    const initialValues = {
        firstName: user.firstName,
        lastName: user.lastName,
        email: user.email,
        password: '',
        confirmPassword: '',
        allowedReservations: user.allowedReservations
    };

    const validationSchema = Yup.object().shape({
        firstName: Yup.string()
            .required(t('First Name is required')),
        lastName: Yup.string()
            .required(t('Last Name is required')),
        email: Yup.string()
            .email(t('Email is invalid'))
            .required(t('Email is required')),
        password: Yup.string()
            .min(6, t('register.passwordMin')),
        confirmPassword: Yup.string()
            .when('password', (password, schema) => {
                if (password) return schema.required(t('Confirm Password is required'));
            })
            .oneOf([Yup.ref('password')], t('Passwords must match'))
    });

    function onSubmit(fields, { setStatus, setSubmitting }) {
        setStatus();
        accountService.update(user.id, fields)
            .then(() => {
                alertService.success(t('Update successful'), { keepAfterRouteChange: true });
                history.push('.');
            })
            .catch(error => {
                setSubmitting(false);
                alertService.error(error);
            });
    }

    const [isDeleting, setIsDeleting] = useState(false);
    function onDelete() {
        if (window.confirm(t('Are you sure?'))) {
            setIsDeleting(true);
            accountService.delete(user.id)
                .then(() => alertService.success(t('Account deleted successfully')));
        }
    }

    return (
        <Formik initialValues={initialValues} validationSchema={validationSchema} onSubmit={onSubmit}>
            {({ errors, touched, isSubmitting }) => (
                <Form>
                    <h2 className="card-header">{t('Update Account')}</h2>
                    <h4 className="card-header card-subheader">{t('Change Name & Email')}</h4>
                    <div className="form-row">
                        <div className="form-group col-6 first-name-marg">
                            <label>{t('First Name')}</label>
                            <Field name="firstName" type="text" className={'form-control' + (errors.firstName && touched.firstName ? ' is-invalid' : '')} />
                            <ErrorMessage name="firstName" component="div" className="invalid-feedback" />
                        </div>
                    </div>
                    <div className="form-row">
                        <div className="form-group col-6 first-name-marg">
                            <label>{t('Last Name')}</label>
                            <Field name="lastName" type="text" className={'form-control' + (errors.lastName && touched.lastName ? ' is-invalid' : '')} />
                            <ErrorMessage name="lastName" component="div" className="invalid-feedback" />
                        </div>
                    </div>
                    <div className="form-row">
                        <div className="form-group col-6 last-name-marg">
                            <label>Email</label>
                            <Field name="email" type="text" className={'form-control' + (errors.email && touched.email ? ' is-invalid' : '')} />
                            <ErrorMessage name="email" component="div" className="invalid-feedback" />
                        </div>
                    </div>

                    <div className="form-row">
                        <div className="form-group">
                            <h4 className="card-header card-subheader card-subheader-2">{t('Change Password')}</h4>
                            <p className="rent-agree-marg">{t('update.password')}</p>
                        </div>
                    </div>
                    <div className="form-row">
                        <div className="form-group col-6 first-name-marg">
                            <label>{t('Password')}</label>
                            <Field name="password" type="password" className={'form-control' + (errors.password && touched.password ? ' is-invalid' : '')} />
                            <ErrorMessage name="password" component="div" className="invalid-feedback" />
                        </div>
                    </div>
                    <div className="form-row">
                        <div className="form-group col-6 last-name-marg">
                            <label>{t('Confirm Password')}</label>
                            <Field name="confirmPassword" type="password" className={'form-control' + (errors.confirmPassword && touched.confirmPassword ? ' is-invalid' : '')} />
                            <ErrorMessage name="confirmPassword" component="div" className="invalid-feedback" />
                        </div>
                    </div>
                    <div className="form-group">
                        <button type="submit" disabled={isSubmitting} className="btn btn-primary update-btn">
                            {isSubmitting && <span className="spinner-border spinner-border-sm mr-1"></span>}
                            {t('Update')}
                        </button>
                        <button type="button" onClick={() => onDelete()} className="btn btn-danger delete-btn" disabled={isDeleting}>
                            {isDeleting
                                ? <span className="spinner-border spinner-border-sm"></span>
                                : <span>{t('Delete')}</span>
                            }
                        </button>
                    </div>

                    <div className="cust-ft-top">
                        <h3 className="card-header cust-footer">
                            <Link to="." className="btn btn-link">{t('Cancel')}</Link>
                        </h3>
                    </div>
                </Form>
            )}
        </Formik>
    )
}

export { Update };